import React, {useEffect, useState} from 'react'
import {Button} from "../../components/Button";
import {useMutation} from "@tanstack/react-query";
import {TextContent} from "./TextContent";
import {InteractiveTextArea} from "../../components/input/InteractiveTextArea";
import {TbMathFunction} from "react-icons/tb";
import {getTaskFeedback} from "../../services/AIRepository";
import {useError} from "../../hooks/useError";
import {AiOutlineCheckCircle, AiOutlineCloseCircle} from "react-icons/ai";
import ComplexParser from "./ComplexParser";

export function Subtask({id, content, providedSolution=null}) {


    console.log(providedSolution)
    const [shortAnswer, setShortAnswer] = useState("");
    const [longAnswer, setLongAnswer] = useState("");
    const [feedback, setFeedback] = useState(null);
    const [solution, setSolution] = useState(providedSolution);
    const [showSolution, setShowSolution] = useState(false);
    const [loading, setLoading] = useState(false);
    const [totalPoints, setTotalPoints] = useState(0)
    const [maxPoints, setMaxPoints] = useState(1)
    const letters = ["a", "b", "c", "d", "e", "f", "g", "h"];

    const {setErrorMessage} = useError();

    const parser = new ComplexParser();

    const {mutate, data, isLoading} = useMutation({
            mutationFn: async () => {
                return await getTaskFeedback(id, longAnswer, setErrorMessage)
            },
            onMutate: () => setLoading(true),
            onSuccess: (data) => {
                const parsedSolution = parser.parseContent([data.solution])
                setFeedback(data.feedback)
                setSolution(parsedSolution)
                setTotalPoints(data.points)
                setLoading(false)
            }
        }
    )

    useEffect(() => {

    }, []);


    return (
        <div className={"mb-3 subtask "} >
            <div className={"fw-bold mb-3 p-2 d-flex "}>
                <p className={"me-3"}>a)</p>
                {
                    content
                }
            </div>


            <div className={"px-1 mt-2"}>

                <InteractiveTextArea
                    value={longAnswer}
                    setValue={setLongAnswer}
                    placeholder={"Ditt løsningsforslag (tekst eller latex)"}
                    disabled={feedback != null}
                ></InteractiveTextArea>
                <Button onClick={() => mutate()} addedClasses={"btn btn-success text-white mt-2 col-2"}
                        loading={loading} hide={feedback != null}>Send inn svar</Button>


                {
                    feedback != null ?
                        <div className={"p-3 px-4 border-bottom"} style={{backgroundColor:(totalPoints === maxPoints ? "#e6f4ea":"#fff3f2")}} >

                            <div className={"d-flex mb-2"}>
                                {
                                    totalPoints === maxPoints ?
                                        <AiOutlineCheckCircle size={24} className={" text-success me-2"}/>
                                        :
                                        <AiOutlineCloseCircle size={24} className={" text-danger me-2"}/>
                                }
                                <p className={"p-0 m-0 fw-bold"}>Tilbakemelding</p>
                            </div>
                            <TextContent value={feedback}/>
                        </div>
                        :
                        null
                }

                {
                    solution != null ?


                        <div  className={" p-3 px-4 "} style={{backgroundColor:"#f0f4f8"}}>
                            <div className={"d-flex align-items-center"}>
                                <TbMathFunction className={"me-2"} size={24}/>
                                <p className={"p-0 m-0  fw-bold"}>Løsningsforslag</p>
                                <button className={"btn btn-dark mx-2"} onClick={() => setShowSolution(!showSolution)}>
                                    {
                                        showSolution ? "Skjul" : "Vis svaret"
                                    }
                                </button>
                            </div>

                            {
                                showSolution ?
                                    solution
                                    :
                                    null
                            }

                        </div>

                        :
                        null
                }

                <div className={"row   ps-3 py-2 d-flex mt-2 mx-1 align-items-center rounded-bottom "}>
                    <p className={"col  m-0 p-0 "}>
                        Poeng: <strong>{totalPoints}</strong> av {maxPoints}
                    </p>

                    <div className={"col-3 d-flex justify-content-end"}>
                        {
                            feedback != null && totalPoints !== maxPoints && totalPoints != null ?
                                <Button addedClasses={"btn-primary text-white"} onClick={() => {
                                    setFeedback(null)
                                    setSolution(null)
                                }}>Prøv igjen</Button>
                            :
                                null
                        }
                    </div>
                </div>

            </div>
        </div>

    );

}